import React, { useEffect, useState } from 'react';
import Sidebar from '../common/Sidebar';
import { AdminHome } from "../../Api/Admin/homeApi"
import toast, { Toaster } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

const Home = () => {
    const [dashboardData, setDashboardData] = useState({
        totalSales: 0,
        totalProducts: 0,
        totalOrders: 0,
        totalCustomers: 0,
        recentOrders: []
    });
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    useEffect(() => {
        const fetchDashboardData = async () => {
            setLoading(true);
            try {
                const token = localStorage.getItem('token');
                const response = await AdminHome(token);
                console.log(response.data.stats);
                if (response.status) {
                    setDashboardData(response.data.stats);
                    setLoading(false);
                }
            } catch (error) {
                toast.error('Error fetching dashboard data');
                console.error('Error fetching dashboard data:', error);
            }
        };

        fetchDashboardData();
    }, []);
    return (
        <div className="flex min-h-screen">
            <Sidebar />
            <Toaster />
            <div className="flex-1 p-6 bg-gray-50" style={{ marginLeft: '16rem' }}>
                {/* Page Header */}
                <header className="mb-6">
                    <h1 className="text-3xl font-bold text-gray-800">Dashboard</h1>
                    <p className="text-gray-600">Welcome back, Admin!</p>
                </header>

                {/* Metrics Section */}
                <section className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
                    <div className="bg-white p-4 shadow rounded">
                        <h2 className="text-lg font-semibold text-gray-700">Total Sales</h2>
                        <p className="mt-2 text-2xl font-bold text-green-500">Rs:{dashboardData.totalSales}</p>
                    </div>
                    <div className="bg-white p-4 shadow rounded cursor-pointer" onClick={() => navigate('/admin/products')}>
                        <h2 className="text-lg font-semibold text-gray-700">Total Products</h2>
                        <p className="mt-2 text-2xl font-bold text-blue-500">{dashboardData.totalProducts}</p>
                    </div>
                    <div className="bg-white p-4 shadow rounded cursor-pointer" onClick={() => navigate('/admin/orders')}>
                        <h2 className="text-lg font-semibold text-gray-700">Total Orders</h2>
                        <p className="mt-2 text-2xl font-bold text-yellow-500">{dashboardData.totalOrders}</p>
                    </div>
                    <div className="bg-white p-4 shadow rounded cursor-pointer" onClick={() => navigate('/admin/customers')}>
                        <h2 className="text-lg font-semibold text-gray-700">Total Customers</h2>
                        <p className="mt-2 text-2xl font-bold text-purple-500">{dashboardData.totalCustomers}</p>
                    </div>
                </section>

                {/* Recent Orders Section */}
                <section className="mb-6">
                    <h2 className="text-xl font-bold text-gray-800 mb-4">Recent Orders</h2>
                    <div className="bg-white shadow rounded overflow-hidden">
                        {dashboardData.recentOrders.length === 0 ? (
                            <div className="p-6 text-center text-gray-500">
                                No recent orders found
                            </div>
                        ) : (
                            <table className="min-w-full text-sm text-left">
                                <thead className="bg-gray-200 text-gray-600 uppercase text-xs">
                                    <tr>
                                        <th className="px-6 py-3">Order ID</th>
                                        <th className="px-6 py-3">Customer</th>
                                        <th className="px-6 py-3">Total</th>
                                        <th className="px-6 py-3">Status</th>
                                        <th className="px-6 py-3">Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {dashboardData.recentOrders.map((order, index) => (
                                        <tr className="border-t cursor-pointer" key={index} onClick={() => navigate(`/admin/orders/${order._id}`)}>
                                            <td className="px-6 py-3">{order._id}</td>
                                            <td className="px-6 py-3">{order.customerName}</td>
                                            <td className="px-6 py-3">{order.totalAmount}</td>
                                            <td className="px-6 py-3">{order.status}</td>
                                            <td className="px-6 py-3">{new Date(order.createdAt).toLocaleDateString('en-US', {
                                                year: 'numeric',
                                                month: 'short',
                                                day: 'numeric',
                                                hour: '2-digit',
                                                minute: '2-digit'
                                            })}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                </section>

            </div>
        </div>
    );
};

export default Home;
